import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react"
import { CREATE_SALE_RETURN } from "../../apollo/mutations"
import closeModal from "../../common/closeModal";
import { dateFormatter } from "../../utils/helperFunctions";

const useCreateSalesReturn = (props) => {

    const [returns, setReturns] = useState([])
    const [errors, setErrors] = useState({})

    const [submit, { loading }] = useMutation(CREATE_SALE_RETURN);

    useEffect(() => {
        if (props?.data) {
            let sales_return = props?.data?.map(item => ({ sale_item_id: item.id, actual_quantity: item.quantity, quantity: 0 }))
            setReturns(sales_return)
        }
    }, [props])

    const onChangeQuantity = (value, index) => {

        let temp = [...returns]
        let item = temp[index]

        item.quantity = value

        setErrors(prev => ({ ...prev, [item.sale_item_id]: value > item.actual_quantity }))
        setReturns(temp)

    }

    const onSubmit = async (e) => {

        e.preventDefault()

        let error_exist = Object.values(errors).some(item => item == true)

        if (error_exist) return;

        let temp = [...returns]
        temp = temp.filter(item => item.quantity > 0).map(item => ({ sale_item_id: item.sale_item_id, quantity: Number(item.quantity) }))
        console.log("final products", temp);

        let payload = {
            variables: {
                input: {
                    return_date: dateFormatter(new Date(), "YYYY-MM-DD"),
                    reason: null,
                    return_items: temp,
                    sales_id: props?.id
                },
            },
        };

        await submit(payload);
        closeModal("add-sales-new");

    }

    return {
        values: {
            data: props?.data || [],
            returns,
            errors,
            loading
        },
        functions: {
            onChangeQuantity,
            onSubmit
        }
    }

}

export default useCreateSalesReturn